import { Injectable } from '@angular/core';
import { CachedhttpService } from './cachedhttp.service';
import { HttpClient } from '@angular/common/http';
import { Booking } from '../interfaces/booking';
import { AppService } from './app.service';


@Injectable({
	providedIn: 'root'
})
export class TourService {

	constructor(
		private cachedHttp: CachedhttpService,
		private httpClient: HttpClient,
		private app: AppService
	) { }


	/**
	 * Get a list of all avalible tours
	 * 
	 * @returns cachedHttp
	 */
	public getTours() {
		const url = this.app.getApiEndpoint() + '/oauth/get-tours'
		return this.httpClient.post(url, {})
	}


	/**
	 * Get a list of all avalible tours
	 * 
	 * @returns http
	 */
	public getToursInventroy() {
		const url = this.app.getApiEndpoint() + '/oauth/get-tours-inventory'
		const params = {
			"lang": "da",
			"from_date": new Date().toISOString().split('T')[0],
			"get_departures": true,
			"show_all": true,
			"show_state": true,
			"show_valid_ticket_types": true,
		}
		return this.httpClient.post(url, params)
	}


	/**
	 * Get tour by id
	 * 
	 * @param id
	 */
	public getTourById(id: string) {
		const url = this.app.getApiEndpoint() + '/oauth/get-tour'
		const params = {
			"id": id,
			"lang": "da",
			"get_departures": true,
			"show_state": true,
			"show_valid_ticket_types": true,
			"show_departure_state": true,
			"show_departure_seats": true,
		}
		return this.httpClient.post(url, params)
	}


	/**
	 * Book a tour
	 */
	public bookTour(bookingData: Booking) {
		bookingData.origin = 'Greenland Travel Leisure';
		bookingData.lang = 'da';
		const url = this.app.getApiEndpoint() + '/oauth/add-to-cart-and-complete-order'
		return this.httpClient.post(url, bookingData)
	}
}
